import { Preferences } from '@capacitor/preferences'

const memory = new Map<string, string>()

export async function initializeStorage() {
  const keys = await Preferences.keys().catch(() => ({ keys: [] as string[] }))
  await Promise.all(
    keys.keys.map(async (key) => {
      const { value } = await Preferences.get({ key })
      if (value != null) {
        memory.set(key, value)
      }
    }),
  )
}

export function getStorage(key: string): string {
  return memory.get(key) ?? ''
}

export function getJsonStorage<T>(key: string, fallback: T): T {
  const value = getStorage(key)
  if (!value) {
    return fallback
  }
  try {
    return JSON.parse(value) as T
  }
  catch {
    return fallback
  }
}

export function setStorage(key: string, value: unknown) {
  const normalized = typeof value === 'string' ? value : JSON.stringify(value)
  memory.set(key, normalized)
  void Preferences.set({ key, value: normalized })
}

export function removeStorage(key: string) {
  memory.delete(key)
  void Preferences.remove({ key })
}

export function clearStorage() {
  memory.clear()
  void Preferences.clear()
}

/** 登出时仅清理鉴权/会话相关键，保留日记、主题、收藏、游戏进度等本地偏好 */
const AUTH_LOGOUT_KEYS = [
  'token',
  'expire',
  'userInfo',
  'user',
  'pendingPaymentOrderId',
  'lastUsedDeviceId',
  'lastUsedAgentId',
  'homeUserPresenceStatus',
]

export function clearAuthStorage() {
  for (const key of AUTH_LOGOUT_KEYS)
    removeStorage(key)

  for (const key of getStorageKeys()) {
    if (
      key.startsWith('chat:')
      || key.startsWith('agentLastMessage_')
      || key === 'agentLastMessages'
      || key.startsWith('cyber-spirit-silent-events_')
    ) {
      removeStorage(key)
    }
  }
}

export function getStorageKeys() {
  return [...memory.keys()]
}
